import store from '@/store';
import resourcesApi from "@/api/resources/resourcesApi";
import vuetify from "@/plugins/vuetify";
import EnglishTranslations from "@/locale/en.ts";

export const storageKeyDefaultDynamicQuestionList = 'defaultDynamicQuestionList'
export const storageKeyPrevIndex = 'previousDynamicQuestionIndex'
export const noDefaultListFoundError = 'no-default-list-found'

export const DynamicQuestionListHelper = {
    isValidDynamicQuestionListObject($data){
        window.console.log($data);

        if($data.dynamic_questions === undefined){
            return false
        }

        if($data.dynamic_questions.length <= 0){
            return false
        }
        return true;
    },
    async getDynamicQuestions($defaultList = false){
        var listId = null;
        if(!$defaultList){
            listId = await this.getCurrentProjectDynamicQuestionsId();
        }
        var response = await resourcesApi.getDynamicQuestionsList(listId)
            .then(
                response => {
                    if(this.isValidDynamicQuestionListObject(response.data)){
                        if($defaultList){
                            let userLang = store.state.userLanguage;
                            let storedData = this.getSavedDefaultQuestions(userLang);
                            storedData[userLang] = response.data;
                            //window.console.log('Right before save');
                            localStorage.setItem(storageKeyDefaultDynamicQuestionList, JSON.stringify(storedData));
                        }
                    }
                    return response;
                }).catch((error) => {
                    this.handleDataRetrievalFailure(error);
                    return undefined;
            });

        return response;
    },

    async getCurrentProjectDynamicQuestionsId() {
        return (
            typeof store.state.currentClientProjectSettings.project === 'object' &&
            store.state.currentClientProjectSettings.project.linked_dynamic_question_list_id !== undefined
        ) ? store.state.currentClientProjectSettings.project.linked_dynamic_question_list_id : null;
    },
    getSavedDefaultQuestions() {
        var storedQuestions = {}
        if (localStorage.getItem(storageKeyDefaultDynamicQuestionList)) {
            try {
                storedQuestions = JSON.parse(localStorage.getItem(storageKeyDefaultDynamicQuestionList));
            } catch (e) {
                localStorage.removeItem(storageKeyDefaultDynamicQuestionList);
                storedQuestions = {}
            }
        }
        return storedQuestions;
    },

    handleDataRetrievalFailure(error) {
        //window.console.log('ERROR FOUND : ');
        if(error.response !== undefined && error.response !== null &&
            error.response.data !== undefined && error.response.data !== null &&
            error.response.data.status !== undefined && error.response.data.status === noDefaultListFoundError)
        {
            //window.console.log('REMOVE IT ALLLLLL !!!!!!');
            localStorage.removeItem(storageKeyDefaultDynamicQuestionList);
        }
        //window.console.log(error.response.data.status)
        //window.console.log('Handled Failure DQL');
        let userLang = store.state.userLanguage;
        let storedData = this.getSavedDefaultQuestions(userLang);

        let defaultQuestionJSONObj = this.getDefaultQuestionJSONObject(userLang);
        /*window.console.log('DQJO -------');
        window.console.log(defaultQuestionJSONObj);*/

        if (storedData[userLang] === undefined) {
            storedData[userLang] = defaultQuestionJSONObj;
            localStorage.setItem(storageKeyDefaultDynamicQuestionList, JSON.stringify(storedData));
        }
    },
   getDefaultQuestionJSONObject(userLang){
        let defaultQuestionString = undefined;

        if (userLang === null || userLang === undefined || userLang.toLowerCase() !== vuetify.framework.lang.current.toLowerCase()) {
            defaultQuestionString = EnglishTranslations.defaultDynamicQuestion;
        } else {
            defaultQuestionString = vuetify.framework.lang.t('$vuetify.defaultDynamicQuestion');
        }

        let defaultQuestionJSONObj = {}

        try {
            defaultQuestionJSONObj = JSON.parse(defaultQuestionString);
        } catch (e) {
            let fallbackString = this.getFallBackQuestionString();
            defaultQuestionJSONObj = JSON.parse(fallbackString);
        }

        return defaultQuestionJSONObj;
    },
    getFallBackQuestionString(){
        //window.console.log('getting fallback');
        return '{"dynamic_questions":[{"id":null,"question":"Do I have the correct PPE? (D-ERR)","correct_answer":"1"}]}';
    },
    async storeCurrentDynamicQuestionListInMemory($dynamicQuestionList){
        if(this.isValidDynamicQuestionListObject($dynamicQuestionList)){
            //window.console.log('SAVING VALID OBJECT');
            await store.dispatch('setCurrentDynamicQuestionList',$dynamicQuestionList)
        }else{
            //window.console.log('DID NOT SAVE!!');
        }
    },
    async getCurrentDynamicQuestion() {
        let userLang = store.state.userLanguage;
        /*window.console.log(userLang);
        window.console.log('GETTING CURRENT DQUESTIONS !!');*/
        let currentList = await store.getters.getCurrentValidatedDynamicQuestionList;
        /*window.console.log('CURRENT MEMORY LIST');
        window.console.log(currentList);
        window.console.log('-------------------');*/

        if(currentList === null || !this.isValidDynamicQuestionListObject(currentList)){
            //window.console.log('INVALID  MEMOBJE');
            let savedQuestions = await this.getSavedDefaultQuestions();
            if(savedQuestions[userLang] !== undefined && this.isValidDynamicQuestionListObject(savedQuestions[userLang])){
                //window.console.log('Stored Object is fine');
                currentList = savedQuestions[userLang];
            }else{
                /*window.console.log('FURRY BAD !!!!');
                window.console.log(savedQuestions[userLang]);*/
                currentList = undefined;
            }
        }

        if(currentList === undefined){
            return undefined;
        }

        let prevIndex = parseInt(localStorage.getItem(storageKeyPrevIndex));
        //window.console.log('BEFORE INDEX');
        let newIndex = 0;
        if (prevIndex !== null && prevIndex !== undefined && prevIndex < (currentList.dynamic_questions.length - 1)) {
            newIndex = prevIndex + 1;
        }
        //window.console.log('INDEX ' + newIndex);
        localStorage.removeItem(storageKeyPrevIndex);
        localStorage.setItem(storageKeyPrevIndex, newIndex);
        //window.console.log(currentList.dynamic_questions);
        return currentList.dynamic_questions[newIndex];
    }
}

